import * as React from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import useExternalStore from "hooks/useExternalStore";
import AppConfig from "util/AppConfig";
import CurrentUser from "logic/users/CurrentUser";
import useTelemetrySettings from "logic/telemetry/useTelemetrySettings";
const getPostHogSettings = () => {
  const { host, api_key: key } = AppConfig.telemetry() || {};
  return {
    host,
    key
  };
};
const init = (key, host) => {
  posthog.init(key, {
    autocapture: false,
    api_host: host,
    capture_pageview: false,
    capture_pageleave: false,
    cross_subdomain_cookie: false,
    persistence: "localStorage+cookie",
    strict_script_versioning: true
  });
  return posthog;
};
const TelemetryInit = ({ children }) => {
  const { host, key } = getPostHogSettings();
  const currentUser = useExternalStore(CurrentUser, (state) => state.currentUser);
  const { data: settings } = useTelemetrySettings({ enabled: !!currentUser });
  if (!(settings == null ? void 0 : settings.telemetry_enabled) || !host || !key) {
    return children;
  }
  return /* @__PURE__ */ React.createElement(PostHogProvider, { client: init(key, host) }, children);
};
export default TelemetryInit;
